import { render } from "./TalentPool.vue?vue&type=template&id=77f14b62"
import script from "./TalentPool.vue?vue&type=script&lang=js"
export * from "./TalentPool.vue?vue&type=script&lang=js"

import exportComponent from "G:\\workspace\\screened-cv-parser\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__